import React, {Fragment} from "react";
import { styles } from './SidebarBaseMenuIcon';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(styles);

const HistoryRightArrowIcon = () => {
    const classes = useStyles();
    return (
        <Fragment>
            <img src={require('../../assets/icons/History_ArrowRight.svg')} alt={'alt'} className={classes.iconWidth}  />
        </Fragment>
    )
}

export default HistoryRightArrowIcon;
